module.exports = "/work-site/img/height.d8823fd7.png";